import {FC, useEffect, useState} from "react";
import {calendarService} from "../../../entities/calendar";
import {IStudentData} from "../../../entities/student";
import {StudentRegularScheduleCalendar} from "../../../widgets/scheduleCalendar";
import classes from './studentLessonsCalendar.module.scss'

interface IProps {
    student: IStudentData;
    hideTitle?: boolean;
}

const getStudentFullName = (student: IStudentData): string => {
    return `${student.last_name} ${student.first_name} ${student.middle_name}`.trim()
}

const getTgAccountTitle = (username: string): string => {
    if(!username) return ''

    return username.startsWith('@') ? username : `@${username}`
}

export const StudentScheduleCalendar: FC<IProps> = ({student, hideTitle = false}) => {

    const tgAccountId = student.work_tg_ids?.[0] ? String(student.work_tg_ids[0]) : ''
    const [resolvedTgAccountTitle, setResolvedTgAccountTitle] = useState<string>(getTgAccountTitle(student.work_tg_name || ''))
    const tutorUserId = Number(student.user_id ?? 0)
    const studentTagIds = (student.tags || []).map(tag => String(tag.id))
    const hasRequiredData = Boolean(
        Number(student.id) > 0 &&
        tutorUserId > 0 &&
        Number(tgAccountId) > 0
    )

    useEffect(() => {
        const initialTitle = getTgAccountTitle(student.work_tg_name || '')
        if(initialTitle){
            setResolvedTgAccountTitle(initialTitle)
            return
        }

        if(!tgAccountId){
            setResolvedTgAccountTitle('')
            return
        }

        const controller = new AbortController()

        calendarService.getCalendarFilterOptions({
            selected: {
                tgAccountIds: [tgAccountId],
                userIds: [],
                studentIds: [],
                tagIds: [],
                includeCancelled: true,
                includeRescheduled: true,
            },
        }, controller.signal)
            .then(response => {
                if(controller.signal.aborted) return

                const tgAccount = response.tgAccounts.find(item => item.id === tgAccountId)
                setResolvedTgAccountTitle(getTgAccountTitle(tgAccount?.title || tgAccount?.username || ''))
            })
            .catch(() => {
                if(!controller.signal.aborted){
                    setResolvedTgAccountTitle('')
                }
            })

        return () => controller.abort()
    }, [student.work_tg_name, tgAccountId])

    if(!hasRequiredData){
        return (
            <section className={classes.container}>
                <section className={classes.header}>
                    <section>
                        {!hideTitle && <h2 className={classes.title}>Регулярный график</h2>}
                        <p className={classes.subtitle}>
                            Для отображения регулярного графика не хватает данных в карточке студента.
                        </p>
                    </section>
                </section>
            </section>
        )
    }

    return (
        <StudentRegularScheduleCalendar
            studentId={String(student.id)}
            userId={String(tutorUserId)}
            tgAccountId={tgAccountId}
            tagIds={studentTagIds}
            title="Регулярный график"
            hideTitle={hideTitle}
            subtitle={`${getStudentFullName(student)}${resolvedTgAccountTitle ? ` · ${resolvedTgAccountTitle}` : ''}`}
        />
    )
}
